import { APPLICATION_EVENT } from 'constants/events';
import { applyVariables } from 'utilities/parsers';
import { ContextWatcherFactory } from './context_watcher_factory';
import * as Contexts from 'constants/context';
import * as is from 'utilities/is';

export class ContextManager {
    constructor({ eventBus, initialContext = {} }) {
        this.eventBus = eventBus;
        this.externalListeners = [];
        this.watching = [];
        this.contexts = {};
        this.initialContext = initialContext;
        this.eventBus.on(APPLICATION_EVENT.SET_STATE, this.onStateChangeEvent);
        this.persistentContexts.forEach(this.watchContext);
    }

    compileContext(subject) {
        return applyVariables(subject, this.currentState);
    }

    watchContext = context => {
        if (!this.watching.includes(context)) {
            this.watching.push(context);
            this.contexts[context] = ContextWatcherFactory(context, this.initialContext[context], this.eventBus);
            this.contexts[context].onChange(this.watchedContextChange(context))
        }
    }

    unWatchContext = context => {
        if (this.watching.includes(context)) {
            this.watching = this.watching.filter(w => w !== context);
            this.contexts[context].destroy();
            delete this.contexts[context];
        }
    }

    onContextChange(callback) {
        if (this.externalListeners.includes(callback)) {
            return;
        }

        this.externalListeners.push(callback);
    }

    watchedContextChange = contextName => () => {
        this.externalListeners.forEach(e => e(contextName, this.contexts[contextName].state));
    }

    onStateChangeEvent = (stateName, value) => {
        if (this.contexts[stateName]) {
            this.contexts[stateName].state = value;
        }
    }

    set activeContexts(contexts = []) {
        contexts = contexts.concat(this.persistentContexts);
        const inactive = this.watching.filter(w => !contexts.includes(w));
        inactive.forEach(this.unWatchContext);
        contexts.forEach(this.watchContext);
    }

    get currentState() {
        return (
            Object
                .keys(this.contexts)
                .reduce((state, key) => {
                    state[key] = this.contexts[key].state;
                    return state;
                }, {})
        )
    }

    get persistentContexts() {
        return [Contexts.ANNOTATION, Contexts.FORM_DATA, Contexts.LANGUAGE, Contexts.LEVEL];
    }
}